<template>
  <div class="card">
    <div class="card-header">
      <button class="btn btn-outline-info spacer" @click="clearFilter">
        <i class="fe fe-x-circle"></i>
      </button>
      <button class="btn btn-outline-info spacer" @click="getBasic">
        BHCPF
      </button>
      <button class="btn btn-outline-info spacer" @click="getSEP">
        SEP
      </button>
    </div>

    <div class="card-body">
      <highcharts :options="chartOptions"></highcharts>

      <div class="row">
        <div class="col-md-6">
          <label for="inputCity">Start</label>
          <input type="date" class="form-control" v-model="from" />
        </div>
        <div class="col-md-6">
          <label for="inputCity">End</label>
          <input type="date" class="form-control" v-model="to" />
        </div>

        <div class="col-md-12 mt-4">
          <button
            class="btn btn-outline-info btn-block"
            @click="getDashboardLGA"
          >
            Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
      sector: "Basic Healthcare Provision Fund",
      from: "",
      to: "",
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    clearFilter() {
      this.from = "";
      this.to = "";
    },
    getDashboardLGA() {
      this.axios
        .get("/api/v1/auth/dashboardlgainformalcategory/90", {
          params: {
            sector: this.sector,
            from: this.from,
            to: this.to,
          },
        })
        .then((response) => {
          var data = response.data;

          console.log(data[0].wards);
          this.chartOptions = {
            chart: {
              type: "pie",
            },
            title: {
              text: "Vulnerable Groups Data by Category",
            },

            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  // format: '{point.y:.1f}'
                  format:
                    "<b>{point.name}</b>: {point.y} ({point.percentage:.1f} %)",
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: data[0].vulnerablegroups,
          };
        });
    },

    getBasic() {
      this.sector = "Basic Healthcare Provision Fund";
      this.getDashboardLGA();
    },
    getSEP() {
      this.sector = "State Equity Program";
      this.getDashboardLGA();
    },
  },
};
</script>

<style>
</style>
